import { TagCommanderMetricMapper } from '@adapters/tagging/tagCommanderMetricMapper';
import { Injectable } from '@angular/core';
import { TagCommanderService } from 'ngx-tag-commander';

@Injectable({
  providedIn: 'root',
})
export class GetAngularDependenciesService {
  constructor(
    private tagCommanderService: TagCommanderService,
    private tagCommanderMetricMapper: TagCommanderMetricMapper
  ) {}

  getTagCommanderService(): TagCommanderService {
    return this.tagCommanderService;
  }

  getTagCommanderMetricMapper(): TagCommanderMetricMapper {
    return this.tagCommanderMetricMapper;
  }
}
